import React, { useContext } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { AdminContext } from "@/contexts/AdminContext"
import PriceModeSelector from "./components/PriceModeSelector"
import PricingTable from "./components/table"
import { FormValues } from "./types"

interface PricingComponentProps {
  selectedTab: string
  reactHookForm: UseFormReturn<FormValues>
}

const Pricing = ({ selectedTab, reactHookForm }: PricingComponentProps) => {
  const { campingStyles, isParkAdminUser } = useContext(AdminContext)
  return (
    <div className="flex-col w-full">
      {selectedTab === 'pricing_general' && <PriceModeSelector reactHookForm={reactHookForm} />}
      {isParkAdminUser && selectedTab.startsWith('pricing_') && selectedTab !== 'pricing_general' &&
        <PricingTable reactHookForm={reactHookForm} campingStyle={campingStyles.find((style) => style.id === selectedTab.split('_')[1])} />
      }
    </div>
  )
}

export default Pricing
